import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { logEvent } from '~/config/firebase.config';

import styles from './HomeDemoModal.module.css';

function IconInfo() {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4M12 8h.01" />
        </svg>
    );
}
function IconArrow() {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
    );
}

export function HomeDemoModal() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={styles.banner}>
            <div className={styles.info}>
                <div className={styles.iconWrap}>
                    <IconInfo />
                </div>
                <div className={styles.texts}>
                    <div className={styles.title}>{t('home.demo.title')}</div>
                    <div className={styles.limits}>
                        {t('home.demo.limitations.1')} · {t('home.demo.limitations.2')}
                    </div>
                </div>
            </div>
            <button
                type="button"
                className={styles.cta}
                onClick={() => logEvent('home_signup_click', 'Demo', () => navigate('/signup'))}
            >
                {t('home.demo.startTrial')}
                <IconArrow />
            </button>
        </div>
    );
}
